import { useTranslation } from "react-i18next";
import TestCard from "./TestCard";
import SEO from "../common/SEO";


const Testimonials = ({ testimonials }) => {
  const { i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Testimonials & Opinions" : "Pregiate Opinioni & Testimonianze";
  const desc = isEnglish
    ? "Precious opinions and testimonials from great musicians and artists about Nuova Orchestra da Camera Ferruccio Busoni."
    : "Pregiate opinioni e testimonianze di grandi maestri e personalità della musica sull'Orchestra da Camera Ferruccio Busoni.";

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section">
        <div className="container subpage-container">
          <div className="text-center mb-5">
            <p className="text-muted max-w-700 mx-auto mb-0">
              {isEnglish
                ? "Words of appreciation and artistic admiration from celebrated musical figures who have collaborated with the Orchestra."
                : "Pensieri e attestati di stima artistica espressi da illustri personalità del panorama musicale internazionale."}
            </p>
          </div>
          <TestCard testimonials={testimonials} />
        </div>
      </section>
    </>
  );
};

export default Testimonials;
